"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignmentsLabel = getAssignmentsLabel;
exports.teamMemberAssignmentsLabels = exports.teamMemberAssignments = exports.archivedReasonsLabel = exports.archivedReasons = exports.companyStatusBadge = exports.companyStatusOptions = exports.companyStatusLabels = exports.companyStatus = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _general = require("../../helpers/general");

var _companyStatusLabels, _companyStatusBadge, _archivedReasonsLabel, _teamMemberAssignment;

var companyStatus = {
  ACTIVE: 'active',
  INITIADED: 'initiated',
  REVIEW: 'review',
  ARCHIVED: 'archived'
};
exports.companyStatus = companyStatus;
var companyStatusLabels = (_companyStatusLabels = {}, (0, _defineProperty2["default"])(_companyStatusLabels, companyStatus.ACTIVE, 'Active'), (0, _defineProperty2["default"])(_companyStatusLabels, companyStatus.INITIADED, 'Initiated'), (0, _defineProperty2["default"])(_companyStatusLabels, companyStatus.REVIEW, 'In review'), (0, _defineProperty2["default"])(_companyStatusLabels, companyStatus.ARCHIVED, 'Archived'), _companyStatusLabels);
exports.companyStatusLabels = companyStatusLabels;
var companyStatusOptions = Object.entries(companyStatusLabels).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];

  return {
    value: value,
    label: label
  };
});
exports.companyStatusOptions = companyStatusOptions;
var companyStatusBadge = (_companyStatusBadge = {}, (0, _defineProperty2["default"])(_companyStatusBadge, companyStatus.ACTIVE, 'active'), (0, _defineProperty2["default"])(_companyStatusBadge, companyStatus.INITIADED, 'active'), (0, _defineProperty2["default"])(_companyStatusBadge, companyStatus.REVIEW, 'pending'), (0, _defineProperty2["default"])(_companyStatusBadge, companyStatus.ARCHIVED, 'inactive'), _companyStatusBadge);
exports.companyStatusBadge = companyStatusBadge;
var archivedReasons = {
  DUPLICATE: 'duplicate',
  FAKE: 'fake',
  END_OF_SERVICE: 'end_of_services',
  OTHER: 'other',
  COMPETITOR: 'competitor'
};
exports.archivedReasons = archivedReasons;
var archivedReasonsLabel = (_archivedReasonsLabel = {}, (0, _defineProperty2["default"])(_archivedReasonsLabel, archivedReasons.DUPLICATE, 'Duplicate'), (0, _defineProperty2["default"])(_archivedReasonsLabel, archivedReasons.FAKE, 'Fake'), (0, _defineProperty2["default"])(_archivedReasonsLabel, archivedReasons.END_OF_SERVICE, 'End of services'), (0, _defineProperty2["default"])(_archivedReasonsLabel, archivedReasons.COMPETITOR, 'Competitor'), (0, _defineProperty2["default"])(_archivedReasonsLabel, archivedReasons.OTHER, 'Other'), _archivedReasonsLabel);
exports.archivedReasonsLabel = archivedReasonsLabel;
var teamMemberAssignments = {
  BILLING_CONTACT: 'billingContact',
  LEGAL_REPRESENTATIVE: 'legalRepresentative'
};
exports.teamMemberAssignments = teamMemberAssignments;
var teamMemberAssignmentsLabels = (_teamMemberAssignment = {}, (0, _defineProperty2["default"])(_teamMemberAssignment, teamMemberAssignments.BILLING_CONTACT, 'Billing Contact'), (0, _defineProperty2["default"])(_teamMemberAssignment, teamMemberAssignments.LEGAL_REPRESENTATIVE, 'Authorized Representative'), _teamMemberAssignment);
exports.teamMemberAssignmentsLabels = teamMemberAssignmentsLabels;

function getAssignmentsLabel(isLegalRepresentative, isBillingContact) {
  var assignments = [];

  if (isLegalRepresentative) {
    assignments.push(teamMemberAssignmentsLabels.legalRepresentative);
  }

  if (isBillingContact) {
    assignments.push(teamMemberAssignmentsLabels.billingContact);
  }

  return assignments.length ? assignments.join(', ') : (0, _general.friendlyLabel)(null);
}